//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { server } from "@/services/constants";
import {
  createIncorporateDocket,
  getIncorporateMatterById,
  // ⭐ เพิ่มใหม่ — ดึง Matter ทั้งหมด เพื่อใช้เป็น options ของ v-autocomplete
  // ตอนเพิ่ม Docket ใหม่แบบไม่ได้มาจากหน้า Matter (ไม่มี matter_id ใน query)
  getAllIncorporateMatter,
  // ⭐ เพิ่มใหม่ — บันทึก Change Tracker ทั้งชุด (ดูเพิ่มที่ services/api-dtime/api_incorporate.js
  // ถ้ายังไม่มีฟังก์ชันนี้ ให้เพิ่ม wrapper เรียก PUT /incorporate-docket-change-replace-all/:docket_id)
  replaceIncorporateDocketChangeAll,
} from "@/services/api-dtime/api_incorporate";
import TimeLineOperations from "../timeline/TimeLineOperations.vue";
import InvoiceSectionPanel from "../payment-invoice/InvoiceSectionPanel.vue";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";
const moment = require("moment-timezone");
export default {
  name: "incorporate-docket-add",
  components: { SuccessDialog, SuccessDialogPush, TimeLineOperations, InvoiceSectionPanel },
  data() {
    return {
      existingShareholdersCount: 0,
      directorsListShow: [],
      shareholdersNumber: 0,
      shareholdersMaxNumber: 0,
      matterId: null,
      loadingSave: false,

      // ⭐ true เมื่อ route มี query matter_id (เช่นมาจากปุ่ม "New Docket"
      // ในหน้า IncorporateMatterView) — ใช้คุมว่าจะ readonly หรือให้เลือก Matter
      isFromMatter: false,

      // ⭐ state สำหรับโหมด "Add New" ตรง ๆ — รายชื่อ Matter ทั้งหมด
      // ที่ดึงมาให้เลือกผ่าน v-autocomplete แทนการพิมพ์เอง เพื่อบังคับให้
      // ทุก Docket ต้องผูกกับ Matter ที่มีอยู่จริงในระบบเสมอ (กัน docket
      // ลอย ๆ ที่ join กับ matter ไม่ได้ในอนาคต)
      matterList: [],
      loadingMatterList: false,
      selectedMatter: null,

      rules: {
        required: (v) =>
          (v !== null && v !== undefined && String(v).trim() !== "") ||
          "กรุณากรอกข้อมูล",
      },

      form: {
        matter_id: null,
        client_name: "",
        entity_type: "",
        registration_no: "",
        inquiry_topic: "",
        date_received: "",
        date_submitted: "",
        next_due_date: "",
        doc_category: [],
        attachments: [],
        change_tracker: [],
        remark: "",
        status: "In Progress",
        quotation_id: 0
      },

      // ✅ UI state เท่านั้น — ยังไม่มี table รองรับฝั่ง backend
      // (ฟิลด์เหล่านี้เก็บไว้สำหรับงานเพิ่ม backend ในรอบถัดไป)
      trackerDetail: {
        shareholders: [
          {
            full_name: "",
            nationality: "",
            ordinary_shares: 0,
            preferred_shares: 0,
          },
        ],
        directors: [{ full_name: "", nationality: "", authorized: "No" }],
        reg_capital: "",
        paidup_capital: "",
        company_name: "",
        reg_address: "",
        audit_firm: "",
        auditor_name: "",
        auditor_license_no: "",
        accountant_firm: "",
        accountant_name: "",
        others_detail: "",
      },
      // ✅ UI state: { [trackerKey]: ['agency1', 'agency2'] }
      selectedAgencies: {},

      docCategoryOptions: [
        "Company Incorporation Documents | เอกสารตั้งบริษัท",
        "Certified Copy + Registration Items + Application",
        "Memorandum of Association | บช.บริคณห์สนธิ",
        "Articles of Association | ข้อบังคับ",
        "List of Shareholders (Form BorJor.5) | บัญชีรายชื่อผู้ถือหุ้น",
        "Financial Statement Submission Forms (SorBorChor.3)",
        "Tax Information | ข้อมูลภาษี",
        "Share Certificates / Share Register | ใบหุ้น/ทะเบียนหุ้น",
        "Minutes of Board of Directors' Meeting",
        "Minutes of Extraordinary Shareholders' Meeting",
        "Minutes of Annual General Shareholders' Meeting",
        "BOI Documents / Promotion Certificate",
        "Various Licenses / Permits | ใบอนุญาตต่าง ๆ",
        "Agreements / Contracts | สัญญาต่าง ๆ",
        "Legal Opinion | ความเห็นทางกฎหมาย",
        "Work Rules | ข้อบังคับการทำงาน",
        "Due Diligence Report",
        "Others | อื่น ๆ",
      ],

      trackerOptions: [
        { key: "shareholders", label: "👥 Shareholders | ผู้ถือหุ้น" },
        { key: "directors", label: "👔 Directors | กรรมการบริษัท" },
        { key: "reg-capital", label: "💰 Registered Capital (THB)" },
        { key: "paidup-capital", label: "💵 Paid-up Capital (THB)" },
        { key: "company-name", label: "🏢 Company Name | ชื่อบริษัท" },
        { key: "reg-address", label: "📍 Registered Address (Head Office)" },
        { key: "auditor", label: "📋 Auditor | ผู้สอบบัญชี" },
        { key: "accountant", label: "📊 Accountant | ผู้ทำบัญชี" },
        { key: "others", label: "📝 Others | อื่น ๆ" },
      ],

      agencyOptions: [
        "กรมพัฒนาธุรกิจการค้า (DBD)",
        "คปภ. (OIC)",
        "ประกันสังคม (SSO)",
        "สรรพากร (Revenue)",
        "การนิคมอุตสาหกรรม (IEAT)",
        "สถานฑูต (Embassy)",
        "กรมการกงสุล (Consular)",
        "สำนักงานเขต / เทศบาล / อบต.",
        "BOI",
        "กรมศุลกากร (Customs)",
        "อื่น ๆ (Others)",
      ],

      // statusOptions: [
      //   // { label: "In Progress | กำลังดำเนินการ", value: "In Progress" },
      //   // { label: "Complete | เสร็จสิ้น", value: "Complete" },
      //   // {
      //   //   label: "Request Payment | ขอเรียกเก็บเงิน",
      //   //   value: "Request Payment",
      //   // },
      //   // { label: "Cancelled | ยกเลิก", value: "Cancelled" },
      // ],

      dialogAdd: false,
      dialogAddPush: false,
      text_color: "text-h5 green--text text-center",
      title: "",
      message: "",
      link: "",

      //timeline 
      timelineStatus: "In Progress",
      status_note: "",
      visible_check: false,
      dialogDelete: false,
      timeline_case_id: 0,
      module_name: "Corporate",
      modeOperations: "New",
      tabselect: 0,
      reportlist: [],
      statuslist: [
        // "รับเรื่อง",
        // "ยื่นฟ้อง",
        // "สืบพยาน",
        // "รอคำพิพากษา",
        // "อุทธรณ์/ฎีกา",
        // "ปิดคดี",
      ],

      //quotations
      formQutations: {
        salesOrderId: 0,
        price: 0,
        customerName: "",
        currency: "",
      },
      salesOrderList: [],
      invoiceList: [],
      // invoiceMenu: false,
      // invoiceMenuPay: false,
      invoiceStatusList: ["Draft", "Requested", "Invoiced", "Paid"],
      quotationscheckstatus: '',
      matterdatalist: []
    };
  },
  computed: {
    entityTypeLabel() {
      const map = {
        "Limited Company": "Limited Company | บริษัทจำกัด",
        "Public Company Limited": "Public Company Limited | บริษัทมหาชนจำกัด",
        Foundation: "Foundation | มูลนิธิ",
        "Representative Office": "Representative Office | สำนักงานผู้แทนการค้า",
        Individual: "Individual | บุคคลธรรมดา",
      };
      return map[this.form.entity_type] || this.form.entity_type || "-";
    },
    requestPaymentDisabled() {
      const price = Number(this.formQutations.price);
      const salesOrderId = Number(this.formQutations.salesOrderId);
      const matterId = Number(this.form.matter_id);

      const isPriceValid = !isNaN(price) && price > 0;
      const isSalesOrderIdValid = !isNaN(salesOrderId) && salesOrderId > 0;
      const isMatterIdValid = !isNaN(matterId) && matterId > 0;

      return !(isPriceValid && isSalesOrderIdValid && isMatterIdValid);
    },
    shareholdersAddedFromTracker() {
      return this.trackerDetail.shareholders.reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0
      );
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    await this.loaddataLitigationCourtStatus()
    await this.loaddataSalesOrder()
    this.$hideLoader();
    this.matterId = this.$route.query.matter_id || null;
    this.isFromMatter = !!this.matterId;
    this.form.matter_id = this.matterId;

    if (this.isFromMatter) {
      // กรณีมาจากปุ่ม "New Docket" ในหน้า Matter — โหลด matter เดียว readonly เหมือนเดิม
      await this.loadMatter(this.matterId);
    } else {
      // ⭐ กรณี Add New ตรง ๆ — โหลดรายชื่อ Matter ทั้งหมดมาให้เลือก
      await this.loadMatterList();
    }
    this.sendToStatus(this.form.status);
  },

  methods: {
    onOrdinarySharesInput(index) {
      const total = this.shareholdersNumber + this.shareholdersAddedFromTracker;

      if (total > this.shareholdersMaxNumber) {
        const row = this.trackerDetail.shareholders[index];
        const currentValue = Number(row.ordinary_shares) || 0;
        const overflow = total - this.shareholdersMaxNumber;
        const adjustedValue = Math.max(0, currentValue - overflow);

        row.ordinary_shares = adjustedValue;

        this.setupAlertDialog(
          true,
          "แจ้งเตือน",
          `จำนวนหุ้นสามัญรวม (Current + Added) เกินยอดหุ้นทั้งหมดที่มี (Number of Shares) ระบบปรับจำนวนหุ้นในแถวที่กำลังแก้ไขให้เท่ากับยอดคงเหลือให้อัตโนมัติแล้ว`,
          "text-h5 orange--text text-center",
        );
      }
    },
    //quotations 
    async loaddataSalesOrder() {
      try {
        const res = await api.getQuotatinsForDocketCore(Number(localStorage.getItem(server.COMPANYID)));
        this.salesOrderList = res.data || [];

      } catch (error) {
        console.error("loaddataSalesOrder error:", error);
      }
    },
    onSelectSO(so) {
      // component ส่ง object ของ quotation ที่เลือกมาให้แล้ว (หรือ null ถ้าเคลียร์ค่า)
      if (!so) {
        this.formQutations.price = "";
        this.formQutations.customerName = "";
        this.formQutations.currency = "";
        this.quotationscheckstatus = "";
        return;
      }
      this.quotationscheckstatus = so.status;
      this.formQutations.price = Number(so.subtotal);
      this.formQutations.customerName = so.customer_name || "";
      this.formQutations.currency = so.currency || "";
    },
    //end quotattions
    //timelinestatus
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemConfirm() {
      this.tabselect = 1;
      this.dialogDelete = false;
    },

    handleRequestStatus(value) {
      this.form.status = value
    },
    sendToStatus(value) {
      const selectedItem = this.statuslist.find(
        item => item.module_id === value
      )
      this.timelineStatus = Number(selectedItem.timeline_status_id)
    },
    previewInvoice(item) {
      const routeData = this.$router.resolve(
        `/edit-invoice/${item.inv_id_preview}/inv_h/edit`
      );
      window.open(routeData.href, '_blank');
    },
    async loaddataLitigationCourtStatus() {
      const result = await api.getClientTimelineStatusCongFigByModule("Corporate");
      this.statuslist = (result.data || []).map(item => ({
        ...item,
        module_id: item.module_id
      }));

    },
    //end
    async loadMatter(id) {
      try {
        const res = await getIncorporateMatterById(id);
        const matter = res.data;
        if (matter) {
          this.form.client_name =
            matter.company_name || matter.client_name || matter.full_name || "";
          this.form.entity_type = matter.entity_type || "";
          this.form.registration_no = matter.registration_no || "";
          // เก็บลง matterdatalist ให้ validation ตอน save อ้างอิงได้เหมือนโหมด Add New
          this.matterdatalist = [matter];
        }
      } catch (error) {
        console.error("Error loading matter:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่พบข้อมูล Matter ที่อ้างอิงมา กรุณาตรวจสอบลิงก์ที่เข้ามา",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ โหลด Matter ทั้งหมด (ไม่ pagination) มาเป็น options ของ v-autocomplete
    // ใช้ getAllIncorporateMatter ตามที่มี endpoint อยู่แล้ว (GET /incorporate-matter)
    // หมายเหตุเผื่ออนาคต: ถ้าจำนวน Matter ในระบบโตมากจนโหลดทีเดียวหนักเกินไป
    // ให้เปลี่ยนมาใช้ getIncorporateMatterPagination + ค้นหาแบบ server-side
    // (debounce การพิมพ์ค้นหา) แทนการโหลดทั้งหมดในครั้งเดียวแบบนี้
    async loadMatterList() {
      this.loadingMatterList = true;
      try {
        const res = await getAllIncorporateMatter();

        const list = Array.isArray(res.data) ? res.data : [];
        this.matterdatalist = list;
        this.matterList = list.map((m) => ({
          text: `${m.client_name ||
            m.company_name ||
            m.full_name ||
            "-"} (${m.registration_no || "-"})`,
          value: m.id,
          raw: m,
        }));

      } catch (error) {
        console.error("Error loading matter list:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดรายชื่อลูกค้าจาก Matter ได้",
          "text-h5 red--text text-center",
        );
      } finally {
        this.loadingMatterList = false;
      }
    },

    // ⭐ เมื่อเลือก Matter จาก v-autocomplete — เติมข้อมูล client_name /
    // entity_type / registration_no / matter_id ให้อัตโนมัติ เหมือนกับ
    // กรณีมาจากปุ่ม "New Docket" ในหน้า Matter (loadMatter ด้านบน)
    onMatterChange(selected) {

      if (!selected || !selected.raw) {
        this.onMatterClear();
        return;
      }


      const m = selected.raw;
      this.form.matter_id = m.id;
      this.form.client_name =
        m.company_name || m.client_name || m.full_name || "";
      this.form.entity_type = m.entity_type || "";
      this.form.registration_no = m.registration_no || "";
      this.shareholdersMaxNumber = m.number_of_shares || 0;

      // ⭐ หาผลรวมของ ordinary_shares ทุกคนใน shareholders array
      this.shareholdersNumber = (selected.raw.shareholders || []).reduce(
        (sum, sh) => sum + (Number(sh.ordinary_shares) || 0),
        0
      );
      this.existingShareholdersCount = (selected.raw.shareholders || []).length;
      this.directorsListShow = selected.raw.directors || [];
    },

    // ⭐ เคลียร์ค่าทั้งหมดที่ผูกกับ matter เดิม เมื่อกดล้างตัวเลือก
    // (กันค่าตกค้างจาก matter ก่อนหน้าหลุดไปบันทึกผิดราย)
    onMatterClear() {
      this.selectedMatter = null;
      this.form.matter_id = null;
      this.form.client_name = "";
      this.form.entity_type = "";
      this.form.registration_no = "";
      this.existingShareholdersCount = 0;   // ⭐ เพิ่มใหม่
    },

    // ⭐ Multi-select — คลิกเพื่อเพิ่ม/เอาออกจากรายการที่เลือก
    selectDocCategory(cat) {
      const idx = this.form.doc_category.indexOf(cat);
      if (idx >= 0) {
        this.form.doc_category.splice(idx, 1);
      } else {
        this.form.doc_category.push(cat);
      }
    },
    // ⭐ Single-select (radio behavior) สำหรับ Change Tracker
    // ใช้ array ที่มีสมาชิกอย่างมาก 1 ตัวเสมอ เพื่อให้ logic เดิม
    // (buildChangesPayload, replaceAllForDocket ฝั่ง backend) ใช้ต่อได้
    // โดยไม่ต้องแก้โครงสร้างข้อมูล
    // ⭐ Multi-select — คลิกเพื่อเพิ่ม/เอาออกจากรายการที่เลือก
    // ตอนเอาออก ต้องล้าง selectedAgencies ของ key นั้นด้วย (ตัวอื่นที่เลือกอยู่ไม่กระทบ)
    selectTracker(key) {
      const idx = this.form.change_tracker.indexOf(key);
      if (idx >= 0) {
        this.form.change_tracker.splice(idx, 1);
        this.$delete(this.selectedAgencies, key);
      } else {
        this.form.change_tracker.push(key);
        this.$set(this.selectedAgencies, key, []);
      }
    },

    isAgencySelected(trackerKey, agency) {
      return (this.selectedAgencies[trackerKey] || []).includes(agency);
    },

    toggleAgency(trackerKey, agency) {
      if (!this.selectedAgencies[trackerKey]) {
        this.$set(this.selectedAgencies, trackerKey, []);
      }
      const list = this.selectedAgencies[trackerKey];
      const idx = list.indexOf(agency);
      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.push(agency);
      }
    },

    addShareholderRow() {
      this.trackerDetail.shareholders.push({
        full_name: "",
        nationality: "",
        ordinary_shares: 0,
        preferred_shares: 0,
      });
    },
    addDirectorRow() {
      this.trackerDetail.directors.push({
        full_name: "",
        nationality: "",
        authorized: "No",
      });
    },

    getDocketStatusColor(status) {
      const map = {
        "In Progress": "blue lighten-4",
        Complete: "green lighten-4",
        "Request Payment": "pink lighten-4",
        Cancelled: "red lighten-4",
      };
      return map[status] || "grey lighten-3";
    },
    getDocketStatusTextColor(status) {
      const map = {
        "In Progress": "blue darken-2",
        Complete: "green darken-2",
        "Request Payment": "pink darken-2",
        Cancelled: "red darken-2",
      };
      return map[status] || "grey darken-1";
    },

    validateForm() {
      // ⭐ กรณี Add New ตรง ๆ — บังคับต้องเลือก Matter ก่อนเสมอ
      // (กัน docket ที่ไม่มี matter_id ผูกอยู่ ซึ่งจะ join ข้อมูลไม่ได้ในอนาคต
      // และอาจชน FK constraint ฝั่ง backend ถ้ามีการบังคับ NOT NULL ไว้)
      if (!this.isFromMatter && !this.form.matter_id) {
        this.setupAlertDialog(
          true,
          "Check information",
          "กรุณาเลือกลูกค้า (Client Name) จากรายการ Matter ก่อนบันทึก",
          "text-h5 red--text text-center",
        );
        return false;
      }
      if (!this.form.inquiry_topic || !this.form.inquiry_topic.trim()) {
        this.setupAlertDialog(
          true,
          "Check information",
          "กรุณากรอก Inquiry Topic",
          "text-h5 red--text text-center",
        );
        return false;
      }
      if (!this.form.date_received) {
        this.setupAlertDialog(
          true,
          "Check information",
          "กรุณากรอก Date Received",
          "text-h5 red--text text-center",
        );
        return false;
      }
      // ⭐ เพิ่มใหม่ — บังคับกรอก Next Due Date เพราะหน้า Incorporate
      // Overview ใช้ field นี้เป็นตัวหลักในการคำนวณ Overdue / Due Soon
      // และรายการ "Docket ที่ใกล้ครบกำหนด" ทั้งหมด (ดู upcomingDockets,
      // isOverdue ใน IncorporateOverview.vue) ถ้าเว้นว่างไว้ docket นี้
      // จะไม่ถูกนับรวมในหน้า Overview เลยโดยไม่มีการแจ้งเตือนใด ๆ
      if (!this.form.next_due_date) {
        this.setupAlertDialog(
          true,
          "Check information",
          "กรุณากรอก Next Due Date | วันครบกำหนดถัดไป (ใช้คำนวณสถานะ Overdue/Due Soon ในหน้า Overview)",
          "text-h5 red--text text-center",
        );
        return false;
      }
      // แต่ละ Change Tracker ที่เลือก ต้องมีอย่างน้อย 1 หน่วยงาน
      for (const key of this.form.change_tracker) {
        const agencies = this.selectedAgencies[key] || [];
        if (agencies.length === 0) {
          const label =
            this.trackerOptions.find((t) => t.key === key)?.label || key;
          this.setupAlertDialog(
            true,
            "Check information",
            `กรุณาเลือกหน่วยงานที่ต้องดำเนินการสำหรับ "${label}" อย่างน้อย 1 หน่วยงาน`,
            "text-h5 red--text text-center",
          );
          return false;
        }
      }
      return true;
    },

    buildFormData() {
      const fd = new FormData();
      const company_id = localStorage.getItem(server.COMPANYID);
      const user_id = localStorage.getItem(server.USER_ID);

      if (this.form.matter_id) fd.append("matter_id", this.form.matter_id);
      fd.append("client_name", this.form.client_name);
      fd.append("inquiry_topic", this.form.inquiry_topic);
      fd.append("doc_category", "");
      // ⭐ change_tracker ตรงนี้ส่งไปเป็นค่าเริ่มต้นเฉยๆ — backend จะ sync
      // ทับด้วยค่าจริงอีกทีหลังจากเรียก replace-all changes สำเร็จ (ดู saveDocket)
      fd.append("change_tracker", "");

      // ⭐ แก้ไข (รอบ 2 — หลังตรวจ repository จริงแล้ว) — date_received และ
      // next_due_date ผ่านการบังคับกรอกจาก validateForm() มาแล้วเสมอ จึงส่ง
      // ค่าตรง ๆ ได้เลย ส่วน date_submitted (ไม่บังคับกรอก) ส่งกลับไปแบบเดิม
      // เสมอ (value || "") แทนที่จะ "ไม่ append field เลยเมื่อว่าง" ตามที่เคย
      // แก้ไว้รอบแรก เพราะพบว่า incorporate_docket.repository.js ฝั่ง
      // exports.update() ใช้ Sequelize Model.update() ซึ่งจะ "ข้าม field ที่
      // เป็น undefined ไปเฉย ๆ ไม่แตะค่าเดิมใน DB เลย" (ยืนยันจาก pattern
      // invoice_id ในไฟล์เดียวกัน: `data.invoice_id !== undefined ? ... :
      // undefined` ที่ตั้งใจอาศัยพฤติกรรมนี้) — ถ้าไม่ append field ตอนผู้ใช้
      // ลบ date_submitted ที่เคยกรอกไว้จนว่างเพื่อ "ล้างค่า" DB จะไม่ถูกล้าง
      // ให้เลย จึงย้ายหน้าที่ sanitize "" → null ไปทำที่ repository แทน
      // (ดู sanitizeDateOnly() ใน incorporate_docket.repository.js) แล้ว
      // ให้ frontend ส่งค่าตรง ๆ เสมอแบบง่าย ๆ พอ
      fd.append("date_received", this.form.date_received);
      fd.append("next_due_date", this.form.next_due_date);
      fd.append("date_submitted", this.form.date_submitted || "");

      fd.append("status", this.form.status);
      fd.append("remark", this.form.remark || "");
      fd.append("company_id", company_id);
      fd.append("user_create", user_id);
      fd.append("quotation_id", Number(this.formQutations.salesOrderId));

      if (this.form.attachments && this.form.attachments.length > 0) {
        this.form.attachments.forEach((file) => fd.append("file", file));
      }

      return fd;
    },

    // ✅ รวม label ของ change tracker ที่เลือกไว้เป็น string เดียว
    // (เนื่องจาก backend มี field change_tracker เป็น text เดี่ยว — ใช้เป็นค่าตั้งต้น
    // ก่อน backend sync ทับด้วยค่าจริงจากตาราง incorporate_docket_change)
    changeTrackerLabel() {
      return this.form.change_tracker
        .map((key) => {
          const opt = this.trackerOptions.find((t) => t.key === key);
          return opt ? opt.label.replace(/^[^\s]+\s/, "") : key;
        })
        .join(", ");
    },

    // ⭐ แปลง trackerDetail (UI state) + selectedAgencies ให้เป็น
    // payload สำหรับ PUT /incorporate-docket-change-replace-all/:docket_id
    // โครงสร้างต้องตรงกับ change_detail ที่ออกแบบไว้ใน DDL/repository ฝั่ง backend
    buildChangesPayload() {
      return this.form.change_tracker.map((key) => {
        let change_detail = {};

        switch (key) {
          case "shareholders":
            change_detail = {
              items: this.trackerDetail.shareholders
                .filter((s) => s.full_name && s.full_name.trim() !== "")
                .map((s, index) => ({
                  full_name: s.full_name,
                  nationality: s.nationality,
                  ordinary_shares: Number(s.ordinary_shares) || 0,
                  preferred_shares: Number(s.preferred_shares) || 0,
                  // ⭐ เพิ่มใหม่ — ต่อลำดับจากจำนวนแถวเดิมที่มีอยู่แล้วใน Matter
                  // เช่น มี shareholders เดิม 3 คน แถวใหม่จะได้ sort_order = 3, 4, 5, ...
                  sort_order: this.existingShareholdersCount + index,
                })),
            };
            break;
          case "directors":
            change_detail = {
              items: this.trackerDetail.directors
                .filter((d) => d.full_name && d.full_name.trim() !== "")
                .map((d) => ({
                  full_name: d.full_name,
                  nationality: d.nationality,
                  authorized: d.authorized,
                })),
            };
            break;
          case "reg-capital":
            change_detail = {
              amount: Number(this.trackerDetail.reg_capital) || 0,
            };
            break;
          case "paidup-capital":
            change_detail = {
              amount: Number(this.trackerDetail.paidup_capital) || 0,
            };
            break;
          case "company-name":
            change_detail = { name: this.trackerDetail.company_name || "" };
            break;
          case "reg-address":
            change_detail = { address: this.trackerDetail.reg_address || "" };
            break;
          case "auditor":
            change_detail = {
              audit_firm: this.trackerDetail.audit_firm || "",
              auditor_name: this.trackerDetail.auditor_name || "",
              auditor_license_no: this.trackerDetail.auditor_license_no || "",
            };
            break;
          case "accountant":
            change_detail = {
              accountant_firm: this.trackerDetail.accountant_firm || "",
              accountant_name: this.trackerDetail.accountant_name || "",
            };
            break;
          case "others":
            change_detail = { detail: this.trackerDetail.others_detail || "" };
            break;
        }

        return {
          change_type: key,
          change_detail,
          agencies: this.selectedAgencies[key] || [],
        };
      });
    },

    // async saveDocket(mode) {
    //   const docketId = 48;
    //   if (docketId && this.form.change_tracker.length > 0) {
    //     const user_id = localStorage.getItem(server.USER_ID);
    //     const changes = this.buildChangesPayload();

    //     await replaceIncorporateDocketChangeAll(docketId, {
    //       changes,
    //       user_id,
    //       matter_id: this.form.matter_id,
    //     });
    //   }
    // },
    async saveDocket(mode) {
      if (!this.validateForm()) return;

      // ✅ ตรวจว่าลูกค้าใน Quotation ตรงกับลูกค้าของ Matter ที่เลือก
      // กันเคสผูก Quotation ของลูกค้าคนอื่นเข้ากับ Docket ทำให้วางบิลผิดคน
      if (this.formQutations.salesOrderId) {
        const selectedSO = this.salesOrderList.find(
          (item) => Number(item.quotation_id) === Number(this.formQutations.salesOrderId)
        );

        if (!selectedSO) {
          this.setupAlertDialog(
            true,
            "Check information",
            "ไม่พบใบเสนอราคาที่เลือก กรุณาเลือกใหม่อีกครั้ง",
            "text-h5 red--text text-center"
          );
          return;
        }

        // client_id ของ Matter ที่เลือก — อ้างจาก matterdatalist ที่โหลดไว้ตอน loadMatterList()
        const matterData = this.matterdatalist.find(
          (item) => Number(item.id) === Number(this.form.matter_id)
        );

        if (!matterData) {
          this.setupAlertDialog(
            true,
            "Check information",
            "ไม่พบข้อมูลลูกค้า (Matter) กรุณาเลือกลูกค้าใหม่อีกครั้ง",
            "text-h5 red--text text-center"
          );
          return;
        }

        if (Number(selectedSO.client_id) !== Number(matterData.client_id)) {
          this.setupAlertDialog(
            true,
            "ข้อมูลลูกค้าไม่ตรงกัน",
            `ใบเสนอราคา ${selectedSO.doc_no} เป็นของลูกค้า "${selectedSO.customer_name || "-"}" ซึ่งไม่ตรงกับลูกค้าที่เลือกใน Docket นี้ กรุณาตรวจสอบและเลือกใหม่ให้ถูกต้อง`,
            "text-h5 red--text text-center"
          );
          return;
        }
      }

      if (this.timelineStatus == 0 || this.status_note.trim() == "") {
        this.dialogDelete = true;
        return;
      }
      this.loadingSave = true;
      this.$showLoader();

      try {
        const fd = this.buildFormData();
        const createRes = await createIncorporateDocket(fd);
        const docketId = createRes.data?.id;
        var main_id = docketId;

        if (docketId && this.form.doc_category && this.form.doc_category.length > 0) {
          try {
            for (const [index, item] of this.form.doc_category.entries()) {
              const datalist = {
                docket_id: docketId,
                doc_category: item,
                user_create: Number(localStorage.getItem(server.USER_ID)),
              };
              await api.createIncorporateDocketDocCategory(datalist);
            }
          } catch (docCategoryError) {
            console.error("Error creating doc category:", docCategoryError);
            this.$hideLoader();
            this.loadingSave = false;
            this.setupAlertDialog(
              true,
              "Error",
              "บันทึก Docket สำเร็จ แต่เกิดข้อผิดพลาดในการบันทึก Document Category กรุณาเปิด Docket นี้เพื่อเพิ่มหมวดเอกสารอีกครั้ง",
              "text-h5 red--text text-center",
            );
            return;
          }
        }
        var dataadd_timeline = {

          timeline_status_id: Number(this.timelineStatus),
          case_id: Number(main_id),
          module_name: "Corporate",
          case_woker: Number(localStorage.getItem(server.USER_ID)),
          status_time: moment().format("YYYY-MM-DD HH:mm:ss"),
          status_note: this.status_note.trim(),
          visibility: this.visible_check,
        }
        await api.creategetClientTimelineHistory(dataadd_timeline)
        try {
          if (this.quotationscheckstatus == "Submitted") {

            var dataupdateStatus = {
              status: "InProgress"
            }
            await api.updateQuotationsCore(Number(this.formQutations.salesOrderId), dataupdateStatus)
          }
        } catch (quotationsError) {
          console.log(quotationsError)
        }
        try {

          const caseDetailResult = await api.getgetTimelineDataDetail({
            params: { module_name: this.module_name, case_id: Number(main_id) },
          });
          const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };

          const visibilityResult = await api.getgetClientTimelineHistoryShowVisibility({
            params: { module_name: this.module_name, case_id: Number(main_id) },
          });
          const timelineData = visibilityResult.data || [];

          caseInfo.status = timelineData[0]?.status || '';
          caseInfo.lastUpdated = timelineData[0]?.status_time || '';

          const latestUpdate = {
            message: timelineData[0]?.status_note || '',
            date: timelineData[0]?.status_time || '',
          };

          await PDFCaseProgress.createToPDF(
            {
              caseInfo,
              latestUpdate,
              timelineData,
              caseId: Number(main_id),
              moduleName: this.module_name,
            },
            { open: false }
          );
        } catch (pdfError) {
          console.error("PDF generation/upload failed:", pdfError);
          // ไม่ throw ต่อ — ตัดขาดจาก flow หลัก ไม่ให้กระทบการบันทึกคดี/ทนายร่วม/วันนัด/ไฟล์แนบ
        }
        if (docketId && this.form.change_tracker.length > 0) {
          const user_id = localStorage.getItem(server.USER_ID);
          const changes = this.buildChangesPayload();
          await replaceIncorporateDocketChangeAll(docketId, {
            changes,
            user_id,
            matter_id: this.form.matter_id,
          });
        }

        this.$hideLoader();
        this.loadingSave = false;
        if (mode == "Save") {
          // setupAlertDialogPush() ด้านล่าง sync เข้า $store.state.global_push_dialog ให้แล้ว
          this.setupAlertDialogPush(
            true,
            "Success",
            "บันทึกข้อมูลสำเร็จ",
            "text-h5 green--text text-center",
            "/incorporate-docket-list",
          );

        } else {

          var mainid = docketId;
          var matterid = Number(this.form.matter_id);

          var customer_list = this.matterdatalist.find(
            item => Number(item.id) === matterid
          )

          var customer_name_master_show = customer_list.client_name;
          var clientid = customer_list.client_id;

          var dataPush = {
            customer_name_master: customer_name_master_show,
            module_id: 0,
            quotation_id: Number(this.formQutations.salesOrderId),
          }
          if (this.modeOperations == "New") {
            dataPush.module_id = Number(mainid);
          } else {
            dataPush.module_id = Number(this.$route.params.id);
          }

          this.$router.push({
            path: `/new-free-invoice/0/invoice/D/${clientid}/Incorporation`,
            query: dataPush,
          });
        }

      } catch (error) {
        this.$hideLoader();
        this.loadingSave = false;
        console.error("Error creating docket:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "เกิดข้อผิดพลาดในการบันทึก",
          "text-h5 red--text text-center",
        );
      }
    },

    // ⭐ FIX: คอมโพเนนต์ SuccessDialog.vue ผูก v-model กับ
    // $store.state.global_dialog โดยตรง (ไม่ได้ใช้ "status" prop ที่ส่งเข้าไป
    // เลยแม้แต่จุดเดียว) ดังนั้นถ้าตั้งแค่ this.dialogAdd = status เฉย ๆ
    // popup จะไม่เด้งขึ้นมาเลย — ต้อง sync เข้า store ทุกครั้งที่เรียกใช้
    // (อาการที่ผู้ใช้เจอ "กด Save แล้วไม่มีอะไรเกิดขึ้น" ส่วนใหญ่คือ
    // validateForm() หรือ catch error คืนค่า false/throw แล้ว alert ไม่เด้ง
    // เพราะบั๊กนี้ — ไม่ใช่ Save ไม่ทำงานเลย)
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.$store.state.global_dialog = status; // ⭐ ขาดอันนี้ทำให้ dialog ไม่เด้ง
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAddPush = status;
      this.text_color = text_color;
      this.link = link;
      this.$store.state.global_push_dialog = status; // ⭐ กันพลาดถ้าเรียกซ้ำโดยไม่ set store เอง
    },
  },
};
